import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-brush-2-line',
    title: 'Art Classes',
    tag: 'Year-Round',
    description: 'Guided painting sessions for all skill levels. Step-by-step instruction, all supplies included.',
    href: '/art-classes',
    external: false,
    accentColor: '#ff4322',
    img: 'https://public.readdy.ai/ai/img_res/27f9d9f04f8fd0ca798ce51e5ea0e947.jpg',
  },
  {
    icon: 'ri-parent-line',
    title: 'Kids Programs',
    tag: 'Ages 4+',
    description: 'Age-appropriate creative sessions that build confidence and spark imagination in young artists.',
    href: '/art-classes',
    external: false,
    accentColor: '#ff7120',
    img: 'https://readdy.ai/api/search-image?query=children%20painting%20colorful%20artworks%20smiling%20bright%20art%20class%20studio%20vibrant%20orange%20yellow%20paint%20kids%20excited%20joyful%20creative%20learning%20experience&width=600&height=400&seq=srv-kids-v3&orientation=landscape',
  },
  {
    icon: 'ri-user-2-line',
    title: 'Adult Classes',
    tag: 'Social & Fun',
    description: 'Relaxed evening sessions. Paint, unwind, and leave with something you\'re genuinely proud of.',
    href: '/art-classes',
    external: false,
    accentColor: '#ffb300',
    img: 'https://readdy.ai/api/search-image?query=adults%20painting%20social%20class%20evening%20relaxed%20friends%20wine%20glasses%20canvases%20warm%20studio%20lighting%20sophisticated%20premium%20art%20night%20out%20creative&width=600&height=400&seq=srv-adult-v3&orientation=landscape',
  },
  {
    icon: 'ri-cake-3-line',
    title: 'Birthday Parties',
    tag: 'Private Event',
    description: 'Fully hosted private parties for kids and adults. We handle everything — just celebrate.',
    href: '/parties-events',
    external: false,
    accentColor: '#e0285a',
    img: 'https://readdy.ai/api/search-image?query=birthday%20party%20art%20studio%20celebration%20kids%20adults%20painting%20together%20decorations%20balloons%20colorful%20canvases%20joyful%20premium%20photography%20vibrant%20energy&width=600&height=400&seq=srv-bday-v3&orientation=landscape',
  },
  {
    icon: 'ri-team-line',
    title: 'Group Events',
    tag: 'Corporate & Social',
    description: 'Bachelorettes, team outings, special occasions. Fully private and personally guided experiences.',
    href: '/parties-events',
    external: false,
    accentColor: '#ff4322',
    img: 'https://readdy.ai/api/search-image?query=group%20of%20adults%20corporate%20team%20building%20event%20painting%20together%20art%20studio%20laughter%20canvases%20vibrant%20creative%20experience%20social%20bonding%20premium&width=600&height=400&seq=srv-group-v3&orientation=landscape',
  },
  {
    icon: 'ri-gift-2-line',
    title: 'Gift Cards',
    tag: 'Perfect Gift',
    description: 'Give the gift of creativity. Redeemable for any experience at Art Den Studio.',
    href: 'https://app.getoccasion.com/p/n/3mrk3shx9p7bhxywpcu9cg',
    external: true,
    accentColor: '#ffb300',
    img: 'https://readdy.ai/api/search-image?query=gift%20card%20creative%20studio%20art%20experience%20premium%20elegant%20packaging%20gift%20giving%20artistic%20beautiful%20design%20warm%20tones%20studio%20backdrop&width=600&height=400&seq=srv-gift-v3&orientation=landscape',
  },
];

const ServicesOverview = () => {
  return (
    <section className="py-20 md:py-28" style={{ background: '#f6f1eb' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-artden-coral" />
              <span className="section-label">What We Offer</span>
            </div>
            <h2 className="font-cormorant font-medium text-artden-dark leading-[1.0] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
              Every Experience<br />
              <em className="font-light italic text-artden-coral">Made to Inspire</em>
            </h2>
          </div>
          <p className="font-outfit text-artden-mid text-sm leading-relaxed max-w-xs">
            From first-time painters to birthday parties — Art Den Studio in Nazareth, PA has a creative experience for everyone.
          </p>
        </div>

        {/* Service grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
              style={{ minHeight: '280px' }}
            >
              {/* Background image */}
              <img
                src={service.img}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 transition-opacity duration-500" style={{ background: `linear-gradient(to top, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.6) 50%, rgba(8,8,8,0.2) 100%)` }} />

              {/* Content */}
              <div className="relative z-10 h-full flex flex-col justify-between p-6 min-h-[280px]">
                {/* Top */}
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-black/30 backdrop-blur-sm border border-white/10">
                    <i className={`${service.icon} text-lg text-white`}></i>
                  </div>
                  <span
                    className="font-outfit text-xs font-semibold px-3 py-1 rounded-full border backdrop-blur-sm"
                    style={{ background: `${service.accentColor}25`, color: service.accentColor, borderColor: `${service.accentColor}40` }}
                  >
                    {service.tag}
                  </span>
                </div>

                {/* Bottom */}
                <div>
                  <h3 className="font-cormorant text-2xl font-semibold text-white mb-2 leading-tight">
                    {service.title}
                  </h3>
                  <p className="font-outfit text-white/65 text-sm leading-relaxed mb-5">
                    {service.description}
                  </p>
                  {service.external ? (
                    <a
                      href={service.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-sm font-semibold group-hover:gap-3 transition-all"
                      style={{ color: service.accentColor }}
                    >
                      Learn More
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </a>
                  ) : (
                    <a
                      href={service.href}
                      className="inline-flex items-center gap-1.5 text-sm font-semibold group-hover:gap-3 transition-all"
                      style={{ color: service.accentColor }}
                    >
                      Learn More
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA row */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://artdenstudio.com/calendar/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-artden-coral hover:brightness-110 text-white font-semibold px-8 py-4 rounded-full transition-all inline-flex items-center gap-2.5 whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-event-line"></i>
            </span>
            Reserve Your Spot
          </a>
          <Link
            to="/parties-events"
            className="border border-artden-dark/25 hover:border-artden-coral text-artden-dark hover:text-artden-coral font-semibold px-8 py-4 rounded-full transition-all inline-flex items-center gap-2.5 whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cake-3-line"></i>
            </span>
            Plan Your Party
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
